import React from 'react'
import $ from 'jquery'
import { Button } from '@progress/kendo-react-buttons'
import services from '../../../services';
import TlkTable from '../../../components/tlelrik/table/tlkTable';

const queryString = require('query-string');
var moment = require('moment')
const dateFormat = "YYYY-MM-DD";

let listdefaultRequest = { Filters: null, "SortBy": "id", "IsSortTypeDESC": true, "IsPagination": true, "Page": 1, "PageSize": 100 }

let tablesjson = {
    "RecentGenInvoice": {
        columnkeyMap: {
            "n doc": "Nº Doc",
            "Entidade": "Entidade",
            "Invoice_date": "Data fatura",
            "flag": "Sinalizado",
        },
        actionbuttons: {Invoice_File: "Fatura",  File: "Montante"  },
        popUpTabName: "Faturas pendentes",
        listApilink: "Revenue/GetMultipleInvoiceList",
        requestMethod: "post",
        notAction: false,
        noDownloadButton: true,
        Filters: {
            invoiceId: []
        },
        modulename: "RecentGenInvoice"
    },
}

class RecentInvoiceGenPopUp extends React.Component {

    state = {
        linkData: tablesjson[this.props.tableName],
        telkikTable: null,
        popUpForm: null,
        tlkState: null
    }

    componentDidMount(){
        this.defaultState()
    }
    
    componentDidUpdate(preProp){
        if(preProp.date !== this.props.date){
            this.defaultState()
        }
    }

    closePopup = () => {
        $("#recent-invoice-modal").trigger('click');
    }
    
    /* Carregar estado de página padrão  */

    defaultState = () => {
        let linkData = { ...tablesjson }
        linkData = tablesjson[this.props.tableName];

        // console.log("linkdata", this.props.tableName, linkData)
        this.setState({
            linkData: linkData,
            telkikTable: null,
            tlkState:{
                take: 100,
                skip: 0,
                group: [],
                exporting: false,
            }
        }, () => this.getListData())
    }

     /*Para obter dados para a tabela usando apis */

     getListData = async () => {
        if (!this.state.linkData)  return
        let Request = this.getAllFilter();
        if (this.state.linkData.singleEntity && (!Request.Filters.entity_id && !Request.Filters.invoice_id)) return
        this.setState({
            totalcount: 0
        })
        let method = this.state.linkData.requestMethod;
        let link = this.state.linkData.listApilink;
        let columnkeyMap = this.state.linkData.columnkeyMap;
        let res = await services.apiCall.requestApi(link, Request, method);
        var invoicecode = [];
        if (res) {
            res.map((_row, index) => {
                if (_row.invoiceHistory) {
                    _row.invoiceHistory.map((_r, i) => {
                        invoicecode = [];
                        if (_r.file_Link && _r.invoiceType) {
                            invoicecode = _r.invoiceType.split("-");
                            if (invoicecode[0] === "IVF" || invoicecode[0] === "IVP" || invoicecode[0] === "API") {
                                _row.document_url = "/api/" + _r.file_Link.replace("file:///C:/DevelopmentIVPD", "");
                            } else {
                                _row.invoice_url = "/api/" + _r.file_Link.replace("file:///C:/DevelopmentIVPD", "");
                            }
                        }
                    })
                }
                Object.keys(columnkeyMap).map(function (key) {
                    if (key === "n doc") {
                        _row[columnkeyMap[key]] = _row.no
                    } else if (key === "Entidade") {
                        _row[columnkeyMap[key]] = _row.busEntidade.nome

                    } else if (key === "entityObject") {
                        _row[columnkeyMap[key]] = _row.entity_id ? _row.entityObject.nome : ""
                    } else if (key === "flag") {
                        _row[columnkeyMap[key]] = _row['flag'];
                    } else if (key === "Invoice_date" || key === "issue_date_time") {
                        _row[columnkeyMap[key]] = moment(_row['issue_date_time']).format(dateFormat);
                    } else if (key === "pag_limit") {
                        _row[columnkeyMap[key]] = _row['deadline_date'] ? moment(_row['deadline_date']).format(dateFormat) : moment(_row['issue_date_time']).format(dateFormat);
                    } else if (key === "is_doc_generated") {
                        _row[columnkeyMap[key]] = parseInt(_row['is_doc_generated']) === 1 ? "Sim" : "Não";
                    } else if (key === "Interest_to_date") {
                        _row[columnkeyMap[key]] = services.money.format(_row.service_tax);
                    } else if (key === "Valor c/ IVA") {
                        _row[columnkeyMap[key]] = services.money.format(_row.total_amount);
                    } else if (key === "valor_cativo") {
                        _row[columnkeyMap[key]] = services.money.format(_row.valor_cativo);
                    } else if (key === "Valor IVA") {
                        _row[columnkeyMap[key]] = services.money.format(_row.iva);
                    } else if (key === "add_Amonut_text") {
                        _row[columnkeyMap[key]] = _row.allTransaction && _row.allTransaction[0] ? _row.allTransaction[0].comment : "";
                    } else if (key === "for_invoice_id") {
                        _row[columnkeyMap[key]] = _row.for_invoice_id ? "Pagamento da Fatura" : "Pagamento Antecipado";
                    } else if (key === "is_paid") {
                        _row[columnkeyMap[key]] = _row[key] === 0 ? "Pendente" : "Não Pendente";
                    } else if (key === "Amount_paid") {
                        _row[columnkeyMap[key]] = services.money.format(_row['amount_paid']);
                    } else if (key === "outgoingAmount" && _row['document_type'] === 'Invoice') {
                        _row[columnkeyMap[key]] = services.money.format(_row.total_amount);
                    } else if (key === "incomingAmount" && _row['document_type'] === 'Credit') {
                        _row[columnkeyMap[key]] = services.money.format(_row.total_amount);
                    } else if (key === "valor") {
                        _row["valor"] = _row.trans_type === "CR" ? _row.total_cr : "-" + _row.total_dr;
                        _row[columnkeyMap[key]] = services.money.format(_row["valor"]);
                    } else if (key === "nifap") {
                        _row[columnkeyMap[key]] = _row.busEntidadeDetail.nifap
                    } else if (key === "nome") {
                        if (_row.busEntidade) {
                            _row[columnkeyMap[key]] = _row.busEntidade[key]
                        }
                        else {
                            _row[columnkeyMap[key]] = _row.busEntidadeDetail.nome
                        }
                    } else if (key === "trans_date") {
                        _row[columnkeyMap[key]] = moment(_row['trans_date']).format(dateFormat);
                    } else if (key === "current_balance") {
                        _row[columnkeyMap[key]] = services.money.format(_row["current_balance"]);
                    } else if (key === "total_amount") {
                        _row[columnkeyMap[key]] = services.money.format(_row["total_amount"]);
                    } else if (key === "local") {
                        _row[columnkeyMap[key]] = _row["key"] || '';
                    }else if (key === "amount_paid") {
                        _row[columnkeyMap[key]] = services.money.format(_row[key]);
                    }else if (key === "trans_amount") {
                        _row[columnkeyMap[key]] = services.money.format(_row["trans_amount"]);
                    } else if (key === "balance") {
                        _row[columnkeyMap[key]] = services.money.format(_row["balance"]);
                    }

                    // else if(key==="document_type" && _row.document_type==="Invoice") {
                    //     _row.document_type = "Movements"
                    // }else if(key==="document_type" && _row.document_type==="Credit") {
                    //     _row.document_type = "Crédito"
                    // }
                    else
                        _row[columnkeyMap[key]] = _row[key]
                })
                if (_row.document_type === "Invoice") {
                    _row.document_type = "Movements"
                } else if (_row.document_type === "Credit") {
                    _row.document_type = "Crédito"
                }
            });
            this.setState({
                data: res,
                filterData: res,
                totalcount: window.localStorage.getItem('table_total')
            }, () => this.createTabel())
        }
    }


      /* Para obter filtros para a API */
      getAllFilter = () => {
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        Request.Filters.invoiceId = [...this.props.invoiceIDs]
        return Request;
    }

      /* Obter filtros aplicados na tabela para atualização dinâmica */
      tableFilters = (tlfilter) => {
        let customfilters = this.getAllFilter();
        let columnkeyMap = this.state.linkData.columnkeyMap;
        let tlkState= {...tlfilter};
        let  data = this.makeTlkFilters(tlfilter, columnkeyMap, customfilters);
        let linkData = {...this.state.linkData};
        // console.log("linkData",tlkState);
        // console.log("NewFilters=",data ); 
        // linkData.Filters = data.Filters
        this.setState({
            tlkState,
            linkData
        },()=>this.getListData());
       // return data;
    }

    /* Alterações de filtro de tabela em formatos de API */
    makeTlkFilters = (tlkfilter, columnkeyMap, data) => {
        let tlkState
        let inFilters = {};
        let columnkeyMaprev = {};
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (tlkfilter.filter && tlkfilter.filter.filters && tlkfilter.filter.filters.length > 0) {
            let tkkey = "";
            let tkkeyvalues = [];
            tlkfilter.filter.filters.map((_row, i) => {
                tkkey = "";
                tkkeyvalues = [];
                let checkamount = [];
                if (_row.filters && _row.filters.length > 0) {
                    _row.filters.map((_srow, k) => {
                        tkkey = _srow.field;
                        checkamount = _srow.value.split(" ");
                        if (checkamount[1] && checkamount[1] === "€") {
                            checkamount[0] = checkamount[0].replace(".", "");
                            checkamount[0] = checkamount[0].replace(",", ".");
                            _srow.value = checkamount[0];
                        }
                        _srow.value = $.isNumeric(_srow.value) ? Number(_srow.value) : _srow.value;
                        tkkeyvalues.push(_srow.value)
                    })
                    tkkey = columnkeyMaprev[tkkey];
                    tkkey = tkkey.toLowerCase();
                    inFilters[tkkey] = tkkeyvalues;
                }
            })
        }
        let defaultRequest = listdefaultRequest;    
        defaultRequest.Page = tlkfilter.skip ? (tlkfilter.skip / tlkfilter.take + 1) : 1;
        defaultRequest.PageSize = tlkfilter.take ? tlkfilter.take : 100;
        if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
            defaultRequest.SortBy = columnkeyMaprev[tlkfilter.sort[0].field];
            defaultRequest.IsSortTypeDESC = (tlkfilter.sort[0].dir === "asc") ? false : true;
        }
       // data.inFilters = inFilters;
        return data;
    }


    /* Para carregar o componente da tabela e definir todas as colunas  */

    createTabel = () => {
        if (this.state.linkData && this.state.linkData.columnkeyMap) {
            let columnkeyMap = this.state.linkData.columnkeyMap;
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
            });
            let actionbuttons = this.state.linkData.actionbuttons;
            let telkikTable = <TlkTable
                date={new Date()}
                generateDocument={this.state.linkData.generateDocument}
                noDownloadButton={this.state.linkData.noDownloadButton}
                DocumentGERFIP={this.state.linkData.DocumentGERFIP}
                actionColumnName={this.state.linkData.actionColumnName}
                groupfield={this.state.linkData.groupfield}
                modulename={this.state.linkData.modulename || "fordefault"}
                notAction={this.state.linkData.notAction}
                tlkState={this.state.tlkState}
                deleteFunc={(id) => this.props.handleDelete(id)}
                tableFilters={(filter) => this.tableFilters(filter)}
                list={this.state.filterData}
                actionbuttons={actionbuttons}
                columnlist={columnlist}
                ActionPerform={(action, id) => this.ActionPerform(action, id)} />
            this.setState({
                telkikTable: telkikTable
            })
        }
    }

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        let popUpForm = null;
    }

    render() {
        return (
            <>
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title pl-0">{"Lista de faturas geradas recentemente"}</h4>
                        {/* <Button className="success btn-ivdp-primary mr-2" primary={true} onClick={() => this.AddAdvance()}>{"Adicionar"}</Button> */}
                        <Button className="remoove mr-2 k-primary btn-ivdp-secondary btn-theme" onClick={() => this.closePopup()} >Cancelar</Button>
                    </div>
                    <div className="modal-body">
                        {
                            this.state.telkikTable
                        }
                    </div>
                </div>
            </>
        )
    }
}


export default RecentInvoiceGenPopUp;